import * as React from 'react';
import {
  Filter,
  FilterChangeEvent,
  Operators,
} from '@progress/kendo-react-data-tools';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import { createStyles, makeStyles } from '@material-ui/core';
import { Dispatch } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { savePredMaintenanceFilters } from '../../../store/UserSettings/UserSettingsActions';
import { ASSET } from '../../../utils/constants';
import { GetString } from '../../StringResourceManager';
import { useEffect } from 'react';
import { LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import { locales, LocaleInterface } from '../../AlertsGrid/GridLocale';
import esMessages from '../../../utils/gridMessageKey.json';
import DynamicComboBox from '../../DynamicComboBox';
loadMessages(esMessages, 'fr-CA');

const useStyles = makeStyles(() =>
  createStyles({
    filterArea: {
      Height: '100%',
      width: '100%',
      overflow: 'auto',
    },
  })
);

const PredMaintenanceFilter: React.FC = (): React.ReactElement => {
  const classes = useStyles();
  const dispatch: Dispatch<any> = useDispatch();

  const filter: CompositeFilterDescriptor = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.predMaintenanceFilter
  );

  const onFilterChange = (event: FilterChangeEvent) => {
    savePredMaintenanceFilters(dispatch, event.filter);
  };

  const siteNumbers: string[] = useSelector(
    (state: ApplicationState) => state.assetsReducer.siteNumbers
  );

  const divisions: string[] = useSelector(
    (state: ApplicationState) => state.assetsReducer.divisions
  );

  const nodeTypes: string[] = useSelector(
    (state: ApplicationState) => state.assetsReducer.nodeTypes
  );

  const laneNumbers: string[] = useSelector(
    (state: ApplicationState) => state.assetsReducer.laneNumbers
  );

  const [currentLocale, setCurrentLocale] = React.useState<LocaleInterface>(
    locales[0]
  );

  const selectedLanguage: string = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.selectedLanguage
  );

  useEffect(() => {
    if (selectedLanguage == 'English') {
      setCurrentLocale(locales[0]);
    } else if (selectedLanguage == 'French') {
      setCurrentLocale(locales[1]);
    }
  }, [selectedLanguage]);

  const CustomSiteNumberFilter = (props: any) => {
    const onChangeSiteNumber = (event: any) => {
      props.onFilterChange.call(undefined, {
        nextFilter: { ...props.filter, value: event.target.value },
      });
    };
    return (
      <DynamicComboBox
        onChange={onChangeSiteNumber}
        data={siteNumbers}
        value={props.filter.value}
        placeholder={GetString('STORE_PLACEHOLDER')}
      />
    );
  };

  const CustomLaneNumberFilter = (props: any) => {
    const onChangeLaneNumber = (event: any) => {
      props.onFilterChange.call(undefined, {
        nextFilter: { ...props.filter, value: event.target.value },
      });
    };
    return (
      <DynamicComboBox
        onChange={onChangeLaneNumber}
        data={laneNumbers}
        value={props.filter.value}
        placeholder={GetString('LANE_PLACEHOLDER')}
      />
    );
  };

  const CustomNodeTypeFilter = (props: any) => {
    const onChangeNodeType = (event: any) => {
      props.onFilterChange.call(undefined, {
        nextFilter: { ...props.filter, value: event.target.value },
      });
    };
    return (
      <DynamicComboBox
        onChange={onChangeNodeType}
        data={nodeTypes}
        value={props.filter.value}
        placeholder={GetString('NODE_TYPE_PLACEHOLDER')}
      />
    );
  };

  const CustomDivisionFilter = (props: any) => {
    const onChangeDivision = (event: any) => {
      props.onFilterChange.call(undefined, {
        nextFilter: { ...props.filter, value: event.target.value },
      });
    };
    return (
      <DynamicComboBox
        onChange={onChangeDivision}
        data={divisions}
        value={props.filter.value}
        placeholder={GetString('DIVISION_PLACEHOLDER')}
      />
    );
  };

  return (
    <React.Fragment>
      <LocalizationProvider language={currentLocale.language}>
        <Filter
          value={filter}
          className={classes.filterArea}
          onChange={onFilterChange}
          fields={[
            {
              name: ASSET.FIELD_CUSTOMER_NAME,
              label: GetString('FIELD_DIVISION_LABEL'),
              filter: CustomDivisionFilter,
              operators: Operators.text,
            },
            {
              name: ASSET.FIELD_STORE_NUMBER,
              label: GetString('FIELD_STORE_LABEL'),
              filter: CustomSiteNumberFilter,
              operators: Operators.text,
            },
            {
              name: ASSET.FIELD_LANE_NAME,
              label: GetString('FIELD_LANE_LABEL'),
              filter: CustomLaneNumberFilter,
              operators: Operators.text,
            },
          ]}
        />
      </LocalizationProvider>
    </React.Fragment>
  );
};

export default PredMaintenanceFilter;
